var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOperateIcon3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.26,
    height: 43.808,
    viewBox: "0 0 50.26 43.808",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7628",
    "data-name": "Group 7628",
    transform: "translate(-93.848 -22.041)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7629",
    "data-name": "Group 7629",
    transform: "translate(4.737 1.245)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24197",
    "data-name": "Path 24197",
    d: "M147.7,277a.686.686,0,0,0,.684.684h4.488a.682.682,0,0,0,.684-.684,7.707,7.707,0,0,1,1.806-4.967l-4.146-4.146h0A13.552,13.552,0,0,0,147.7,277Z",
    transform: "translate(-47.171 -221.204)",
    fill: "#86bc26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24198",
    "data-name": "Path 24198",
    d: "M222.919,201.4a13.479,13.479,0,0,0-8.429,3.5l4.146,4.153a7.655,7.655,0,0,1,4.283-1.772Z",
    transform: "translate(-109.473 -159.186)",
    fill: "#86bc26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24199",
    "data-name": "Path 24199",
    d: "M360.3,201.4v5.877a7.634,7.634,0,0,1,4.269,1.772l4.153-4.153h0a13.5,13.5,0,0,0-8.422-3.5Z",
    transform: "translate(-245.482 -159.186)",
    fill: "#86bc26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24200",
    "data-name": "Path 24200",
    d: "M438.29,272.038a7.693,7.693,0,0,1,1.806,4.953V277a.682.682,0,0,0,.684.684h4.488a.682.682,0,0,0,.684-.684,13.551,13.551,0,0,0-3.517-9.113Z",
    transform: "translate(-318.235 -221.21)",
    fill: "#86bc26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24202",
    "data-name": "Path 24202",
    d: "M303.235,329.348V322.5a.684.684,0,0,0-1.368,0v6.844a3.42,3.42,0,1,0,1.368,0Z",
    transform: "translate(-188.427 -271.514)",
    fill: "#86bc26"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_24203",
    "data-name": "Path 24203",
    d: "M170.414,92.706c2.7-9.016-7.442-16.231-14.7-10.676a10.4,10.4,0,0,0-8.46-4.374,10.83,10.83,0,0,0-10.618,10.979v.087a12.251,12.251,0,0,0-.858,24.144,15.365,15.365,0,1,1,30.721.152,10.571,10.571,0,0,0,9.758-10.676,10.883,10.883,0,0,0-5.842-9.636Z",
    transform: "translate(-32.149 -55.615)",
    fill: "#86bc26"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperateIcon3);
export default __webpack_public_path__ + "static/media/operate-icon3.1b4602c2f7b8461241bc2ff8b03325b4.svg";
export { ForwardRef as ReactComponent };